import checkout from "./form";

const {
  formField: {
    description,
    location,
    timezone,
    area,
    project,
    status,
    mapCenter,
    mapZoom,
    profileImage,
    collectIP,
    signShift,
  },
} = checkout;

export default {
  [description.name]: "",
  [location.name]: "",
  [timezone.name]: "",
  [area.name]: [],
  [project.name]: "",
  [status.name]: true,
  [mapCenter.name]: { lat: 40.6974034, lng: -74.1197633 },
  [mapZoom.name]: 13,
  [profileImage.name]: false,
  [collectIP.name]: false,
  [signShift.name]: false,
};
